import * as Booking from '../constants/Booking';
import { getTimeslotParams, isSameTimeslotParams } from '../utils/TimeslotUtils';

const initialState = {
    loginRequried: false,
    shopIcon:'',
    bannerUrl: '',
    description: '',
    categories: [],
    itemsByCategory: {},
    records: [],
    branches: [],
    selectedBookingItem:{},
    availableTimeslots:[],
    timeslotParams: undefined,
    availableNumberOfPeople:[],
    timeslotGroupData: undefined,
    loadingTimeslotGroup: false,
    timeslotPreselect: null,
    prevForm:{},
    form:{},
    submitState: Booking.SubmitState.init,
    submitErrorMessage: '',
    loadingBookingItems: false,
    loadingRecords: false,
    queryByPhone: false,
    record:{},
    grade_available: undefined,
    customizedFields: undefined,
}

// the timeslot pre-select is dropped for good once the user picks a date, branch or timeslot
const keepTimeslotPreselect = (preselect, form) => {
    if (
        preselect &&
        preselect.date === form[Booking.FieldNames.date] &&
        preselect.branch === form[Booking.FieldNames.location] &&
        !form[Booking.FieldNames.timeslot]
    ) {
        return preselect;
    }
    return null;
}

export default (state = initialState, action) => {
    if (action.type === Booking.GET_BOOKING_LIST) {
        return {
            ...state,
            loadingBookingItems: true,
        }
    } else if (action.type === Booking.GET_BOOKING_LIST_FULFILLED) {
        const { categories = [], itemsByCategory = {}, bannerUrl, loginRequried = false, shopIcon, description, grade_available, customizedFields } = action.payload;
        
        return {
            ...state,
            categories,
            itemsByCategory,
            bannerUrl,
            loadingBookingItems: false,
            loginRequried,
            shopIcon,
            description,
            grade_available,
            customizedFields,
        }
    } else if (action.type === Booking.GET_BOOKING_LIST_REJECTED) {
        return {
            ...state,
            categories: [],
            itemsByCategory: {},
            loadingBookingItems: false,
        }
    } else if (action.type === Booking.GET_BOOKING_LIST_CANCELLED) {
        const { error } = action.payload;
        // console.log(error);
        return {
            ...state,
            loadingBookingItems: false,
        }  
    } else if (action.type === Booking.GET_AVAILABLE_TIMESLOTS_FULFILLED) {
        const { timeslots, params } = action.payload;

        // a late response for a date / branch that is no longer selected
        if (!isSameTimeslotParams(params, getTimeslotParams(state.form))) return state;

        return {
            ...state,
            availableTimeslots: timeslots,
            timeslotParams: params,
        }
    } else if (action.type === Booking.GET_TIMESLOT_GROUP) {
        return {
            ...state,
            loadingTimeslotGroup: true,
        }
    } else if (action.type === Booking.GET_TIMESLOT_GROUP_FULFILLED) {
        const { timeslotGroupData } = action.payload;
        const { group = [] } = timeslotGroupData ?? {};

        // flatten the enabled slots of the enabled groups so that the rest of the
        // booking flow (people limit, form fixing) keeps working unchanged
        const availableTimeslots = group
            .filter(g => g.enable)
            .reduce((slots, g) => slots.concat((g.timeslot ?? []).filter(t => t.enable)), []);

        return {
            ...state,
            timeslotGroupData,
            availableTimeslots,
            loadingTimeslotGroup: false,
        }
    } else if (action.type === Booking.GET_TIMESLOT_GROUP_REJECTED || action.type === Booking.GET_TIMESLOT_GROUP_CANCELLED) {
        return {
            ...state,
            loadingTimeslotGroup: false,
        }
    } else if (action.type === Booking.NOT_AVAILABLE_DATE) {
        const form = { ...state.form, 
            [Booking.FieldNames.date]: null
        };
        return {
            ...state,
            prevForm: { ...state.form },
            form,
            timeslotPreselect: keepTimeslotPreselect(state.timeslotPreselect, form),
        }
    } else if (action.type === Booking.GET_AVAILABLE_TIMESLOTS_REJECTED) {
        const { error, params } = action.payload;
        // console.log(error);

        if (!isSameTimeslotParams(params, getTimeslotParams(state.form))) return state;

        return {
            ...state,
            availableTimeslots: [],
            timeslotParams: params,
        }
    } else if (action.type === Booking.SUBMIT_BOOKING) {
        return {
            ...state,
            submitState: Booking.SubmitState.loading,
            submitErrorMessage: '',
        }
    } else if (action.type === Booking.SUBMIT_BOOKING_FULFILLED) {
        const { record } = action.payload;
        return {
            ...state,
            submitState: Booking.SubmitState.success,
            submitErrorMessage: '',
            record,
        }
    } else if (action.type === Booking.SUBMIT_BOOKING_REJECTED || action.type === Booking.SUBMIT_BOOKING_CANCELLED) {
        const { error, message } = action.payload ?? {};
        // console.log(error);
        return {
            ...state,
            submitState: Booking.SubmitState.failed,
            submitErrorMessage: message ?? '',
        }
    } else if (action.type === Booking.GET_RECORD_LIST) {
        return {
            ...state,
            loadingRecords: true,
        }
    } else if (action.type === Booking.GET_RECORD_LIST_FULFILLED) {
        const {
            all = [],
            pending = [],
            success = [],
            fail = [],
            checkedIn = [],
            phone = '',
        } = action.payload;

        return {
            ...state,
            records: {
                [Booking.RecordState.all]: all,
                [Booking.RecordState.pending]: pending,
                [Booking.RecordState.success]: success,
                [Booking.RecordState.fail]: fail,
                [Booking.RecordState.checkedIn]: checkedIn,
            },
            loadingRecords: false,
            queryByPhone: phone.length > 0,
        }
    } else if (action.type === Booking.GET_RECORD_LIST_REJECTED || action.type === Booking.GET_RECORD_LIST_CANCELLED) {
        const { error } = action.payload;
        // console.log(error);
        return {
            ...state,
            loadingRecords: false,
        }
    } else if (action.type === Booking.SELECT_BOOKING_ITEM) {
        const { bookingItem } = action.payload;
        return {
            ...state,
            submitState: Booking.SubmitState.filling,
            submitErrorMessage: '',
            selectedBookingItem: bookingItem,
            prevForm: {},
            form: {},
            availableTimeslots: [],
            timeslotParams: undefined,
            availableNumberOfPeople: [],
            timeslotGroupData: undefined,
            loadingTimeslotGroup: false,
            timeslotPreselect: null,
        }
    } else if (action.type === Booking.DESELECT_BOOKING_ITEM) {
        return {
            ...state,
            submitState: Booking.SubmitState.init,
            submitErrorMessage: '',
            selectedBookingItem: {},
            prevForm: {},
            form: {},
            availableTimeslots: [],
            timeslotParams: undefined,
            availableNumberOfPeople: [],
            timeslotGroupData: undefined,
            loadingTimeslotGroup: false,
            timeslotPreselect: null,
        }
    } else if (action.type === Booking.UPDATE_BOOKING_FORM) {
        const { form } = action.payload;
        return {
            ...state,
            prevForm: { ...state.form },
            form,
            timeslotPreselect: keepTimeslotPreselect(state.timeslotPreselect, form),
        }
    } else if (action.type === Booking.FIX_BOOKING_FORM) {
        const { form } = action.payload;

        if (form) {
            return {
                ...state,
                form,
            }
        }
    } else if (action.type === Booking.SET_TIMESLOT_PRESELECT) {
        const { preselect } = action.payload;
        return {
            ...state,
            timeslotPreselect: preselect,
        }
    } else if (action.type === Booking.UPDATE_AVAILABLE_PEOPLE) {
        const { availableNumberOfPeople } = action.payload;
        return {
            ...state,
            availableNumberOfPeople,
        }
    } else if (action.type === Booking.RESET_BOOKING) {
        return initialState;
    }
    
    return state;
}